// Plugin che installa nell'app vue l'istanza di keycloak js
import * as _libsmKeycloak from 'KPackages/libsm-keycloak'

/**
 * Create a Vue plugin backed by a service-specific Keycloak public client.
 *
 * The shared runtime configuration contains the Account public client under
 * its explicit name. The legacy generic client ID is not reliable because
 * one runtime module is shared by multiple services.
 *
 * @param {string} clientId - The public client ID for the current service.
 * @returns {{install: function}} A Vue plugin exposing the Keycloak manager.
 */
export function createKeycloakPlugin(clientId) {
  const keycloakParams = {
    url: location.protocol + '//' + process.env.VUE_APP_KEYCLOAK_DOMAIN,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId,
  }
  const keycloakManager = new _libsmKeycloak.KeycloakManager(keycloakParams);

  return {
    install(app) {
      app.keycloakManager = keycloakManager
    }
  }
}

const Plugin = createKeycloakPlugin(process.env.VUE_APP_THIS_PUBLIC_CLIENT_ID)

export default Plugin

